:host {
  display: block;
  background-color: red;
}
